import { cn } from '../tokens/cn';
import { cva, focusRing, transitionBase } from '../tokens/variants';

export const inputVariants = cva(
  cn(
    'w-full bg-[var(--tk-surface-bg-elevated)] text-[var(--tk-surface-fg)]',
    'placeholder:text-[var(--tk-surface-fg-subtle)]',
    'border border-[var(--tk-surface-border-strong)] rounded-tk-md',
    focusRing,
    transitionBase,
    'disabled:opacity-60 disabled:cursor-not-allowed',
    'aria-[invalid=true]:border-[var(--tk-danger-bg)] aria-[invalid=true]:focus-visible:ring-[var(--tk-danger-bg)]',
  ),
  {
    variants: {
      size: {
        sm: 'h-8 px-3 text-sm',
        md: 'h-10 px-3.5 text-sm',
        lg: 'h-12 px-4 text-base',
      },
    },
    defaultVariants: { size: 'md' },
  },
);
